import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/**
 * Grid of quick-action shortcut buttons (Create Tenant, Create Plan, ...).
 * Every action must map to a route/handler that already exists elsewhere
 * in the app -- this is a navigation convenience, not new functionality.
 */
const ActionToolbar = ({ actions = [], className }) => (
  <div className={cn('grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4', className)}>
    {actions.map((action) => {
      const Icon = action.icon;
      return (
        <Card
          key={action.label}
          role="button"
          tabIndex={0}
          onClick={action.onClick}
          onKeyDown={(e) => e.key === 'Enter' && action.onClick?.()}
          className="card-hover-lift card-glow flex cursor-pointer flex-col items-start gap-2.5 p-4"
        >
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10 text-primary">
            {Icon && <Icon className="h-4.5 w-4.5" />}
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">{action.label}</p>
            {action.description && <p className="mt-0.5 text-xs text-muted-foreground">{action.description}</p>}
          </div>
        </Card>
      );
    })}
  </div>
);

export const QuickActionButton = ({ icon: Icon, label, onClick }) => (
  <Button variant="outline" size="sm" className="h-8 gap-1.5 text-xs" onClick={onClick}>
    {Icon && <Icon className="h-3.5 w-3.5" />}
    {label}
  </Button>
);

export default ActionToolbar;
